// This file is AUTOGENERATED, do not edit it manually!!!

import { resourcePlanning as resourcePlanningde } from './resourcePlanningResx.de';
import { resourcePlanning as resourcePlanningen } from './resourcePlanningResx.en';
import { resourcePlanning as resourcePlanningen_risk } from './resourcePlanningResx.en_risk';
import { resourcePlanning as resourcePlanninges } from './resourcePlanningResx.es';
import { resourcePlanning as resourcePlanningfr } from './resourcePlanningResx.fr';
import { resourcePlanning as resourcePlanningit } from './resourcePlanningResx.it';
import { resourcePlanning as resourcePlanningnl } from './resourcePlanningResx.nl';
import { resourcePlanning as resourcePlanningpl } from './resourcePlanningResx.pl';
import { resourcePlanning as resourcePlanningpt } from './resourcePlanningResx.pt';
import { resourcePlanning as resourcePlanningru } from './resourcePlanningResx.ru';
import { resourcePlanning as resourcePlanningsk } from './resourcePlanningResx.sk';
import { resourcePlanning as resourcePlanningsv } from './resourcePlanningResx.sv';
import { resourcePlanning as resourcePlanningtr } from './resourcePlanningResx.tr';

const langMap: { [k: string]: Partial<typeof resourcePlanningen> } = {
    de: resourcePlanningde,
    en: resourcePlanningen,
    en_risk: resourcePlanningen_risk,
    es: resourcePlanninges,
    fr: resourcePlanningfr,
    it: resourcePlanningit,
    nl: resourcePlanningnl,
    pl: resourcePlanningpl,
    pt: resourcePlanningpt,
    ru: resourcePlanningru,
    sk: resourcePlanningsk,
    sv: resourcePlanningsv,
    tr: resourcePlanningtr,
};

/* tslint:disable: max-line-length */
export const resourcePlanningResx = {
    /**
    * en: ability to fit
    */
    get ability_to_fit_label() {
        return langMap[ep.resxCulture].ability_to_fit_label || langMap.en.ability_to_fit_label;
    },
    /**
    * en: Add allocation
    */
    get add_allocation_title() {
        return langMap[ep.resxCulture].add_allocation_title || langMap.en.add_allocation_title;
    },
    /**
    * en: Add approver
    */
    get add_approver_button() {
        return langMap[ep.resxCulture].add_approver_button || langMap.en.add_approver_button;
    },
    /**
    * en: Add to project
    */
    get add_to_project() {
        return langMap[ep.resxCulture].add_to_project || langMap.en.add_to_project;
    },
    /**
    * en: Add user
    */
    get add_user_link() {
        return langMap[ep.resxCulture].add_user_link || langMap.en.add_user_link;
    },
    /**
    * en: Allocate resources
    */
    get allocate_resources() {
        return langMap[ep.resxCulture].allocate_resources || langMap.en.allocate_resources;
    },
    /**
    * en: Allocated
    */
    get allocated_label() {
        return langMap[ep.resxCulture].allocated_label || langMap.en.allocated_label;
    },
    /**
    * en: Allocated hours
    */
    get AllocatedHoursColumn() {
        return langMap[ep.resxCulture].AllocatedHoursColumn || langMap.en.AllocatedHoursColumn;
    },
    /**
    * en: Allocation was approved by {0} on {1}
    */
    get allocation_approved_alert() {
        return langMap[ep.resxCulture].allocation_approved_alert || langMap.en.allocation_approved_alert;
    },
    /**
    * en: Hard
    */
    get allocation_hard_label() {
        return langMap[ep.resxCulture].allocation_hard_label || langMap.en.allocation_hard_label;
    },
    /**
    * en: Allocation has been created
    */
    get allocation_has_been_created() {
        return langMap[ep.resxCulture].allocation_has_been_created || langMap.en.allocation_has_been_created;
    },
    /**
    * en: Allocation has been updated
    */
    get allocation_has_been_updated() {
        return langMap[ep.resxCulture].allocation_has_been_updated || langMap.en.allocation_has_been_updated;
    },
    /**
    * en: Allocation percentage
    */
    get allocation_percentage_label() {
        return langMap[ep.resxCulture].allocation_percentage_label || langMap.en.allocation_percentage_label;
    },
    /**
    * en: This period already includes allocation
    */
    get allocation_period_conflict() {
        return langMap[ep.resxCulture].allocation_period_conflict || langMap.en.allocation_period_conflict;
    },
    /**
    * en: Allocation was rejected by {0} on {1}
    */
    get allocation_reject_alert() {
        return langMap[ep.resxCulture].allocation_reject_alert || langMap.en.allocation_reject_alert;
    },
    /**
    * en: Resource request has been approved
    */
    get allocation_request_approved_feedback() {
        return langMap[ep.resxCulture].allocation_request_approved_feedback || langMap.en.allocation_request_approved_feedback;
    },
    /**
    * en: Resource request has been rejected
    */
    get allocation_request_rejected_feedback() {
        return langMap[ep.resxCulture].allocation_request_rejected_feedback || langMap.en.allocation_request_rejected_feedback;
    },
    /**
    * en: Resource request has been created
    */
    get allocation_request_waiting_feedback() {
        return langMap[ep.resxCulture].allocation_request_waiting_feedback || langMap.en.allocation_request_waiting_feedback;
    },
    /**
    * en: Allocation required
    */
    get allocation_required() {
        return langMap[ep.resxCulture].allocation_required || langMap.en.allocation_required;
    },
    /**
    * en: Soft
    */
    get allocation_soft_label() {
        return langMap[ep.resxCulture].allocation_soft_label || langMap.en.allocation_soft_label;
    },
    /**
    * en: Changing the allocation type to hard will result in the removal of the resource request
    */
    get allocation_type_change_with_approval_rquest_warning() {
        return langMap[ep.resxCulture].allocation_type_change_with_approval_rquest_warning || langMap.en.allocation_type_change_with_approval_rquest_warning;
    },
    /**
    * en: Hard - confirmed allocation. Soft - tentative allocation.
    */
    get allocation_type_description() {
        return langMap[ep.resxCulture].allocation_type_description || langMap.en.allocation_type_description;
    },
    /**
    * en: Allocation type
    */
    get allocation_type_label() {
        return langMap[ep.resxCulture].allocation_type_label || langMap.en.allocation_type_label;
    },
    /**
    * en: Allocation has been awaiting approval since {0}
    */
    get allocation_waiting_alert() {
        return langMap[ep.resxCulture].allocation_waiting_alert || langMap.en.allocation_waiting_alert;
    },
    /**
    * en: Approve resource request for users?
    */
    get approve_modal_header_text() {
        return langMap[ep.resxCulture].approve_modal_header_text || langMap.en.approve_modal_header_text;
    },
    /**
    * en: Approve request
    */
    get approve_request() {
        return langMap[ep.resxCulture].approve_request || langMap.en.approve_request;
    },
    /**
    * en: This batch operation only applies to resource requests created for users.
    */
    get approve_request_info() {
        return langMap[ep.resxCulture].approve_request_info || langMap.en.approve_request_info;
    },
    /**
    * en: 1#{0} allocation has been approved#{0} allocations have been approved
    */
    get Approve_Success_Message() {
        return langMap[ep.resxCulture].Approve_Success_Message || langMap.en.Approve_Success_Message;
    },
    /**
    * en: Approved by
    */
    get approved_by() {
        return langMap[ep.resxCulture].approved_by || langMap.en.approved_by;
    },
    /**
    * en: Approver
    */
    get approver() {
        return langMap[ep.resxCulture].approver || langMap.en.approver;
    },
    /**
    * en: % of days for the planned allocation duration, where person may have hard allocations on other projects, which will not consume all person’s capacity based on the personal schedule and vacations and company holidays
    */
    get AvailabilityTooltip() {
        return langMap[ep.resxCulture].AvailabilityTooltip || langMap.en.AvailabilityTooltip;
    },
    /**
    * en: Available
    */
    get available_label() {
        return langMap[ep.resxCulture].available_label || langMap.en.available_label;
    },
    /**
    * en: Available projects
    */
    get available_projects() {
        return langMap[ep.resxCulture].available_projects || langMap.en.available_projects;
    },
    /**
    * en: Awaiting approval from
    */
    get awaiting_approval_from() {
        return langMap[ep.resxCulture].awaiting_approval_from || langMap.en.awaiting_approval_from;
    },
    /**
    * en: Be aware that all allocations, assignments, and scheduled hours will be transferred to the selected user.
    */
    get be_aware_all_will_be_transferred() {
        return langMap[ep.resxCulture].be_aware_all_will_be_transferred || langMap.en.be_aware_all_will_be_transferred;
    },
    /**
    * en: Calculation of hours based on
    */
    get calculate_based_message() {
        return langMap[ep.resxCulture].calculate_based_message || langMap.en.calculate_based_message;
    },
    /**
    * en: Capacity
    */
    get capacity_label() {
        return langMap[ep.resxCulture].capacity_label || langMap.en.capacity_label;
    },
    /**
    * en: Check all
    */
    get check_all() {
        return langMap[ep.resxCulture].check_all || langMap.en.check_all;
    },
    /**
    * en: Allocations (bookings) will be created for each project member for the entire duration of their project
    */
    get choice_description_generate_on_project_timeline() {
        return langMap[ep.resxCulture].choice_description_generate_on_project_timeline || langMap.en.choice_description_generate_on_project_timeline;
    },
    /**
    * en: Allocations (bookings) will be created only for task assignees based on the scheduled hours of their assigned tasks
    */
    get choice_description_generate_on_scheduled_hours() {
        return langMap[ep.resxCulture].choice_description_generate_on_scheduled_hours || langMap.en.choice_description_generate_on_scheduled_hours;
    },
    /**
    * en: Generate allocations based on project timelines
    */
    get choice_title_generate_on_project_timeline() {
        return langMap[ep.resxCulture].choice_title_generate_on_project_timeline || langMap.en.choice_title_generate_on_project_timeline;
    },
    /**
    * en: Generate allocations based on scheduled hours
    */
    get choice_title_generate_on_scheduled_hours() {
        return langMap[ep.resxCulture].choice_title_generate_on_scheduled_hours || langMap.en.choice_title_generate_on_scheduled_hours;
    },
    /**
    * en: Ability to fit, %
    */
    get column_title_availability() {
        return langMap[ep.resxCulture].column_title_availability || langMap.en.column_title_availability;
    },
    /**
    * en: Job role match
    */
    get column_title_job_role() {
        return langMap[ep.resxCulture].column_title_job_role || langMap.en.column_title_job_role;
    },
    /**
    * en: Resource
    */
    get column_title_resource() {
        return langMap[ep.resxCulture].column_title_resource || langMap.en.column_title_resource;
    },
    /**
    * en: Skills match
    */
    get column_title_skills() {
        return langMap[ep.resxCulture].column_title_skills || langMap.en.column_title_skills;
    },
    /**
    * en: User
    */
    get column_title_user() {
        return langMap[ep.resxCulture].column_title_user || langMap.en.column_title_user;
    },
    /**
    * en: Company schedule
    */
    get company_schedule_link() {
        return langMap[ep.resxCulture].company_schedule_link || langMap.en.company_schedule_link;
    },
    /**
    * en: Completed projects
    */
    get completed_projects_label() {
        return langMap[ep.resxCulture].completed_projects_label || langMap.en.completed_projects_label;
    },
    /**
    * en: Specify how many copies of the selected unnamed resource to create. Maximum amount: 20 copies.
    */
    get copy_multiple_times_message() {
        return langMap[ep.resxCulture].copy_multiple_times_message || langMap.en.copy_multiple_times_message;
    },
    /**
    * en: Copy "{0}"?
    */
    get copy_unnamed_title() {
        return langMap[ep.resxCulture].copy_unnamed_title || langMap.en.copy_unnamed_title;
    },
    /**
    * en: Copy with allocations
    */
    get copy_with_allocations_label() {
        return langMap[ep.resxCulture].copy_with_allocations_label || langMap.en.copy_with_allocations_label;
    },
    /**
    * en: Demand
    */
    get demand_label() {
        return langMap[ep.resxCulture].demand_label || langMap.en.demand_label;
    },
    /**
    * en: Amount of time a resource is reserved to dedicate to a project.
    */
    get Description_AllocatedMinutes() {
        return langMap[ep.resxCulture].Description_AllocatedMinutes || langMap.en.Description_AllocatedMinutes;
    },
    /**
    * en: Resource internal hourly rate.
    */
    get Description_HourlyRateInternal() {
        return langMap[ep.resxCulture].Description_HourlyRateInternal || langMap.en.Description_HourlyRateInternal;
    },
    /**
    * en: Number of hours a resource is scheduled to spend on each task for a project.
    */
    get Description_ScheduledMinutes() {
        return langMap[ep.resxCulture].Description_ScheduledMinutes || langMap.en.Description_ScheduledMinutes;
    },
    /**
    * en: Edit allocation
    */
    get edit_allocation_title() {
        return langMap[ep.resxCulture].edit_allocation_title || langMap.en.edit_allocation_title;
    },
    /**
    * en: Effortlessly manage resources with Resource Planning
    */
    get effortlessly_namage_resources_label() {
        return langMap[ep.resxCulture].effortlessly_namage_resources_label || langMap.en.effortlessly_namage_resources_label;
    },
    /**
    * en: Find candidates
    */
    get find_candidates() {
        return langMap[ep.resxCulture].find_candidates || langMap.en.find_candidates;
    },
    /**
    * en: Add unnamed resources to find the best match to replace them
    */
    get find_candidates_not_available_no_unnamed() {
        return langMap[ep.resxCulture].find_candidates_not_available_no_unnamed || langMap.en.find_candidates_not_available_no_unnamed;
    },
    /**
    * en: Free
    */
    get free() {
        return langMap[ep.resxCulture].free || langMap.en.free;
    },
    /**
    * en: Generate allocations
    */
    get generate_allocations_action() {
        return langMap[ep.resxCulture].generate_allocations_action || langMap.en.generate_allocations_action;
    },
    /**
    * en: Generate allocations
    */
    get generate_allocations_button() {
        return langMap[ep.resxCulture].generate_allocations_button || langMap.en.generate_allocations_button;
    },
    /**
    * en: Allocations will be generated based on the weekly scheduled hours for this resource.
    */
    get generate_allocations_description() {
        return langMap[ep.resxCulture].generate_allocations_description || langMap.en.generate_allocations_description;
    },
    /**
    * en: This batch operation generates allocations for both users and unnamed resources based on their scheduled project hours.
    */
    get generate_allocations_info() {
        return langMap[ep.resxCulture].generate_allocations_info || langMap.en.generate_allocations_info;
    },
    /**
    * en: To have scheduled hours - assign resource to the task with timelines and estimated hours.
    */
    get generate_allocations_to_have_scheduled_hours() {
        return langMap[ep.resxCulture].generate_allocations_to_have_scheduled_hours || langMap.en.generate_allocations_to_have_scheduled_hours;
    },
    /**
    * en: Generate
    */
    get generate_button() {
        return langMap[ep.resxCulture].generate_button || langMap.en.generate_button;
    },
    /**
    * en: Generating allocations is safe and will not disrupt task assignments or alter workload at the task level
    */
    get generate_button_warning_text() {
        return langMap[ep.resxCulture].generate_button_warning_text || langMap.en.generate_button_warning_text;
    },
    /**
    * en: You need to have the "Manage hard allocations" permission to use this option. Allocations cannot be generated for users with both hard and soft allocations.
    */
    get generate_hard_allocation_disabled_tooltip_description() {
        return langMap[ep.resxCulture].generate_hard_allocation_disabled_tooltip_description || langMap.en.generate_hard_allocation_disabled_tooltip_description;
    },
    /**
    * en: Hard allocations will be generated for users only. Unnamed resources will be skipped.
    */
    get generate_hard_allocation_tooltip_description() {
        return langMap[ep.resxCulture].generate_hard_allocation_tooltip_description || langMap.en.generate_hard_allocation_tooltip_description;
    },
    /**
    * en: Generate as:
    */
    get generate_label() {
        return langMap[ep.resxCulture].generate_label || langMap.en.generate_label;
    },
    /**
    * en: All allocations for the selected users and unnamed resources will be generated based on the current estimated hours and timelines for the corresponding activities.
    */
    get generate_modal_description_text() {
        return langMap[ep.resxCulture].generate_modal_description_text || langMap.en.generate_modal_description_text;
    },
    /**
    * en: All allocations for "{0}" will be generated based on the current estimated hours and timelines for the corresponding activities.
    */
    get generate_modal_description_text_single_resource() {
        return langMap[ep.resxCulture].generate_modal_description_text_single_resource || langMap.en.generate_modal_description_text_single_resource;
    },
    /**
    * en: Generate allocations for selected users and unnamed resources?
    */
    get generate_modal_header_text() {
        return langMap[ep.resxCulture].generate_modal_header_text || langMap.en.generate_modal_header_text;
    },
    /**
    * en: Generate allocations for "{0}"?
    */
    get generate_modal_header_text_single_resource() {
        return langMap[ep.resxCulture].generate_modal_header_text_single_resource || langMap.en.generate_modal_header_text_single_resource;
    },
    /**
    * en: 1#{0} allocation has been generated#{0} allocations have been generated
    */
    get generate_success_message() {
        return langMap[ep.resxCulture].generate_success_message || langMap.en.generate_success_message;
    },
    /**
    * en: Group by job role
    */
    get group_by_job_role_label() {
        return langMap[ep.resxCulture].group_by_job_role_label || langMap.en.group_by_job_role_label;
    },
    /**
    * en: Group by project
    */
    get group_by_project_label() {
        return langMap[ep.resxCulture].group_by_project_label || langMap.en.group_by_project_label;
    },
    /**
    * en: Group by resource
    */
    get group_by_resource_label() {
        return langMap[ep.resxCulture].group_by_resource_label || langMap.en.group_by_resource_label;
    },
    /**
    * en: Hard allocation
    */
    get HardAllocation() {
        return langMap[ep.resxCulture].HardAllocation || langMap.en.HardAllocation;
    },
    /**
    * en: Unnamed resources can be only soft allocated
    */
    get HardAllocationTooltip() {
        return langMap[ep.resxCulture].HardAllocationTooltip || langMap.en.HardAllocationTooltip;
    },
    /**
    * en: Hard and soft allocations let you assign resources to projects with different levels of flexibility.
    */
    get help_tooltip_description() {
        return langMap[ep.resxCulture].help_tooltip_description || langMap.en.help_tooltip_description;
    },
    /**
    * en: Internal rate
    */
    get HourlyRateInternalColumn() {
        return langMap[ep.resxCulture].HourlyRateInternalColumn || langMap.en.HourlyRateInternalColumn;
    },
    /**
    * en: Include soft allocations to workload
    */
    get include_soft_allocations_to_workload() {
        return langMap[ep.resxCulture].include_soft_allocations_to_workload || langMap.en.include_soft_allocations_to_workload;
    },
    /**
    * en: Job role capacity
    */
    get job_role_capacity() {
        return langMap[ep.resxCulture].job_role_capacity || langMap.en.job_role_capacity;
    },
    /**
    * en: Legend
    */
    get legend_title() {
        return langMap[ep.resxCulture].legend_title || langMap.en.legend_title;
    },
    /**
    * en: Message
    */
    get message() {
        return langMap[ep.resxCulture].message || langMap.en.message;
    },
    /**
    * en: Add the rejection or approval reason, or any additional message. It will be added as a separate message to the project details.
    */
    get message_tooltip() {
        return langMap[ep.resxCulture].message_tooltip || langMap.en.message_tooltip;
    },
    /**
    * en: Roles, resources and projects
    */
    get name_column_group_by_JobRole() {
        return langMap[ep.resxCulture].name_column_group_by_JobRole || langMap.en.name_column_group_by_JobRole;
    },
    /**
    * en: Projects and resources
    */
    get name_column_group_by_Project() {
        return langMap[ep.resxCulture].name_column_group_by_Project || langMap.en.name_column_group_by_Project;
    },
    /**
    * en: Resources and projects
    */
    get name_column_group_by_User() {
        return langMap[ep.resxCulture].name_column_group_by_User || langMap.en.name_column_group_by_User;
    },
    /**
    * en: There are no job role visible to you
    */
    get no_jobrole() {
        return langMap[ep.resxCulture].no_jobrole || langMap.en.no_jobrole;
    },
    /**
    * en: Sorry, no job role match selected filters
    */
    get no_jobrole_match_selected_filters() {
        return langMap[ep.resxCulture].no_jobrole_match_selected_filters || langMap.en.no_jobrole_match_selected_filters;
    },
    /**
    * en: There are no project visible to you
    */
    get no_project() {
        return langMap[ep.resxCulture].no_project || langMap.en.no_project;
    },
    /**
    * en: Sorry, no project match selected filters
    */
    get no_project_match_selected_filters() {
        return langMap[ep.resxCulture].no_project_match_selected_filters || langMap.en.no_project_match_selected_filters;
    },
    /**
    * en: There are no scheduled hours on the task assignments for this resource.
    */
    get no_scheduled_hours_description() {
        return langMap[ep.resxCulture].no_scheduled_hours_description || langMap.en.no_scheduled_hours_description;
    },
    /**
    * en: There are no resource visible to you
    */
    get no_user() {
        return langMap[ep.resxCulture].no_user || langMap.en.no_user;
    },
    /**
    * en: Sorry, no resource match selected filters
    */
    get no_user_match_selected_filters() {
        return langMap[ep.resxCulture].no_user_match_selected_filters || langMap.en.no_user_match_selected_filters;
    },
    /**
    * en: The resource request has been reset because the previous approver no longer has the necessary permissions.
    */
    get NormalizeApprovers_Feedback() {
        return langMap[ep.resxCulture].NormalizeApprovers_Feedback || langMap.en.NormalizeApprovers_Feedback;
    },
    /**
    * en: Other hard allocations
    */
    get other_hard_allocations() {
        return langMap[ep.resxCulture].other_hard_allocations || langMap.en.other_hard_allocations;
    },
    /**
    * en: Other projects
    */
    get other_projects_label() {
        return langMap[ep.resxCulture].other_projects_label || langMap.en.other_projects_label;
    },
    /**
    * en: Refers to projects that either do not fall under the applied filters or that you do not have the necessary permissions to access.
    */
    get other_projects_tooltip() {
        return langMap[ep.resxCulture].other_projects_tooltip || langMap.en.other_projects_tooltip;
    },
    /**
    * en: Over
    */
    get over() {
        return langMap[ep.resxCulture].over || langMap.en.over;
    },
    /**
    * en: Overloaded
    */
    get overloaded_label() {
        return langMap[ep.resxCulture].overloaded_label || langMap.en.overloaded_label;
    },
    /**
    * en: Overscheduled hours
    */
    get overscheduled_hours_label() {
        return langMap[ep.resxCulture].overscheduled_hours_label || langMap.en.overscheduled_hours_label;
    },
    /**
    * en: A powerful tool for booking resources at the project level, providing a high-level view of resource usage across all projects to help you make informed strategic decisions
    */
    get planning_onboarding_description() {
        return langMap[ep.resxCulture].planning_onboarding_description || langMap.en.planning_onboarding_description;
    },
    /**
    * en: Welcome to the new Resource Planning feature!
    */
    get planning_onboarding_title() {
        return langMap[ep.resxCulture].planning_onboarding_title || langMap.en.planning_onboarding_title;
    },
    /**
    * en: Project timeline
    */
    get project_timeline_label() {
        return langMap[ep.resxCulture].project_timeline_label || langMap.en.project_timeline_label;
    },
    /**
    * en: AI recommended users
    */
    get recommended_users_label() {
        return langMap[ep.resxCulture].recommended_users_label || langMap.en.recommended_users_label;
    },
    /**
    * en: Re-generate allocations
    */
    get regenerate_allocations_button() {
        return langMap[ep.resxCulture].regenerate_allocations_button || langMap.en.regenerate_allocations_button;
    },
    /**
    * en: This batch operation re-generates allocations for both users and unnamed resources based on their scheduled project hours.
    */
    get regenerate_allocations_info() {
        return langMap[ep.resxCulture].regenerate_allocations_info || langMap.en.regenerate_allocations_info;
    },
    /**
    * en: Re-generate
    */
    get regenerate_button() {
        return langMap[ep.resxCulture].regenerate_button || langMap.en.regenerate_button;
    },
    /**
    * en: You need to have the "Manage hard allocations" permission to use this option. Allocations cannot be re-generated for users with both hard and soft allocations.
    */
    get regenerate_hard_allocation_disabled_tooltip_description() {
        return langMap[ep.resxCulture].regenerate_hard_allocation_disabled_tooltip_description || langMap.en.regenerate_hard_allocation_disabled_tooltip_description;
    },
    /**
    * en: Hard allocations will be re-generated for users only. Unnamed resources will be skipped.
    */
    get regenerate_hard_allocation_tooltip_description() {
        return langMap[ep.resxCulture].regenerate_hard_allocation_tooltip_description || langMap.en.regenerate_hard_allocation_tooltip_description;
    },
    /**
    * en: Re-generate as:
    */
    get regenerate_label() {
        return langMap[ep.resxCulture].regenerate_label || langMap.en.regenerate_label;
    },
    /**
    * en: All allocations for the selected users and unnamed resources will be re-generated based on the current estimated hours and timelines for the corresponding activities. If a user or unnamed resource has been unassigned from activities, their allocations will be deleted.
    */
    get regenerate_modal_description_text() {
        return langMap[ep.resxCulture].regenerate_modal_description_text || langMap.en.regenerate_modal_description_text;
    },
    /**
    * en: Re-generate allocations for selected users and unnamed resources?
    */
    get regenerate_modal_header_text() {
        return langMap[ep.resxCulture].regenerate_modal_header_text || langMap.en.regenerate_modal_header_text;
    },
    /**
    * en: 1#{0} allocation has been re-generated#{0} allocations have been re-generated
    */
    get regenerate_success_message() {
        return langMap[ep.resxCulture].regenerate_success_message || langMap.en.regenerate_success_message;
    },
    /**
    * en: Regular workload
    */
    get regular_workload_label() {
        return langMap[ep.resxCulture].regular_workload_label || langMap.en.regular_workload_label;
    },
    /**
    * en: Reject resource request for users and unnamed resources?
    */
    get reject_modal_header_text() {
        return langMap[ep.resxCulture].reject_modal_header_text || langMap.en.reject_modal_header_text;
    },
    /**
    * en: Reject request
    */
    get reject_request() {
        return langMap[ep.resxCulture].reject_request || langMap.en.reject_request;
    },
    /**
    * en: This batch operation applies to resource requests created for both users and unnamed resources.
    */
    get reject_request_info() {
        return langMap[ep.resxCulture].reject_request_info || langMap.en.reject_request_info;
    },
    /**
    * en: 1#{0} allocation has been rejected#{0} allocations have been rejected
    */
    get Reject_Success_Message() {
        return langMap[ep.resxCulture].Reject_Success_Message || langMap.en.Reject_Success_Message;
    },
    /**
    * en: Rejected by
    */
    get rejected_by() {
        return langMap[ep.resxCulture].rejected_by || langMap.en.rejected_by;
    },
    /**
    * en: Remaining total capacity
    */
    get remaining_total_capacity() {
        return langMap[ep.resxCulture].remaining_total_capacity || langMap.en.remaining_total_capacity;
    },
    /**
    * en: Remaining user capacity
    */
    get remaining_user_capacity() {
        return langMap[ep.resxCulture].remaining_user_capacity || langMap.en.remaining_user_capacity;
    },
    /**
    * en: Replace an unnamed resource with a real user to approve the allocation.
    */
    get replace_unnamed_with_real_to_approve_allocation() {
        return langMap[ep.resxCulture].replace_unnamed_with_real_to_approve_allocation || langMap.en.replace_unnamed_with_real_to_approve_allocation;
    },
    /**
    * en: Replace with a user
    */
    get replace_with_a_user() {
        return langMap[ep.resxCulture].replace_with_a_user || langMap.en.replace_with_a_user;
    },
    /**
    * en: Request for approval
    */
    get request_for_approval_label() {
        return langMap[ep.resxCulture].request_for_approval_label || langMap.en.request_for_approval_label;
    },
    /**
    * en: Request from
    */
    get request_from() {
        return langMap[ep.resxCulture].request_from || langMap.en.request_from;
    },
    /**
    * en: 1#{0} resource was allocated#{0} resources were allocated
    */
    get resource_allocated_plural() {
        return langMap[ep.resxCulture].resource_allocated_plural || langMap.en.resource_allocated_plural;
    },
    /**
    * en: Resource approvals available only for soft allocations
    */
    get resource_approval_selector_disabled_label() {
        return langMap[ep.resxCulture].resource_approval_selector_disabled_label || langMap.en.resource_approval_selector_disabled_label;
    },
    /**
    * en: Disabled users
    */
    get resource_types_disabled_user_label() {
        return langMap[ep.resxCulture].resource_types_disabled_user_label || langMap.en.resource_types_disabled_user_label;
    },
    /**
    * en: Scheduled hours
    */
    get scheduled_hours_label() {
        return langMap[ep.resxCulture].scheduled_hours_label || langMap.en.scheduled_hours_label;
    },
    /**
    * en: See detailed allocations
    */
    get see_detailed_allocations() {
        return langMap[ep.resxCulture].see_detailed_allocations || langMap.en.see_detailed_allocations;
    },
    /**
    * en: Select user
    */
    get select_user() {
        return langMap[ep.resxCulture].select_user || langMap.en.select_user;
    },
    /**
    * en: Skills
    */
    get SkillsColumn() {
        return langMap[ep.resxCulture].SkillsColumn || langMap.en.SkillsColumn;
    },
    /**
    * en: Soft allocation with a resource request
    */
    get soft_allocation_with_a_resource_request_options() {
        return langMap[ep.resxCulture].soft_allocation_with_a_resource_request_options || langMap.en.soft_allocation_with_a_resource_request_options;
    },
    /**
    * en: Soft allocation
    */
    get SoftAllocation() {
        return langMap[ep.resxCulture].SoftAllocation || langMap.en.SoftAllocation;
    },
    /**
    * en: Streamline your project management by effectively allocating and tracking resources.
    */
    get streamline_your_project() {
        return langMap[ep.resxCulture].streamline_your_project || langMap.en.streamline_your_project;
    },
    /**
    * en: Number of hours resource is planned to work on the project, calculated based on the working hours, weekends, public holidays defined in the company settings.
    */
    get total_allocated_hours_calculation_description() {
        return langMap[ep.resxCulture].total_allocated_hours_calculation_description || langMap.en.total_allocated_hours_calculation_description;
    },
    /**
    * en: Total allocated hours = (allocation duration - public holidays) * company working hours * allocation percentage
    */
    get total_allocated_hours_calculation_formula() {
        return langMap[ep.resxCulture].total_allocated_hours_calculation_formula || langMap.en.total_allocated_hours_calculation_formula;
    },
    /**
    * en: Total allocated hours
    */
    get total_allocated_hours_label() {
        return langMap[ep.resxCulture].total_allocated_hours_label || langMap.en.total_allocated_hours_label;
    },
    /**
    * en: Total demand
    */
    get total_demand() {
        return langMap[ep.resxCulture].total_demand || langMap.en.total_demand;
    },
    /**
    * en: Uncheck all
    */
    get uncheck_all() {
        return langMap[ep.resxCulture].uncheck_all || langMap.en.uncheck_all;
    },
    /**
    * en: Underloaded
    */
    get underloaded_label() {
        return langMap[ep.resxCulture].underloaded_label || langMap.en.underloaded_label;
    },
    /**
    * en: Unnamed resource allocation
    */
    get unnamed_resource_allocation() {
        return langMap[ep.resxCulture].unnamed_resource_allocation || langMap.en.unnamed_resource_allocation;
    },
    /**
    * en: Unnamed resource demand
    */
    get unnamed_resource_demand() {
        return langMap[ep.resxCulture].unnamed_resource_demand || langMap.en.unnamed_resource_demand;
    },
    /**
    * en: Unnamed resource workload
    */
    get unnamed_workload_label() {
        return langMap[ep.resxCulture].unnamed_workload_label || langMap.en.unnamed_workload_label;
    },
    /**
    * en: User demand
    */
    get user_demand() {
        return langMap[ep.resxCulture].user_demand || langMap.en.user_demand;
    },
    /**
    * en: You have no users available.
    */
    get users_select_empty_text() {
        return langMap[ep.resxCulture].users_select_empty_text || langMap.en.users_select_empty_text;
    },
    /**
    * en: Vacation
    */
    get vacation_label() {
        return langMap[ep.resxCulture].vacation_label || langMap.en.vacation_label;
    },
    /**
    * en: Working hours – {0} per day.
    */
    get working_hours_message() {
        return langMap[ep.resxCulture].working_hours_message || langMap.en.working_hours_message;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.resourcePlanning = resourcePlanningResx;
